export const dummyCardTravel = {
  error: false,
  data: {
    list: [
      {
        authorId: 6248696,
        authorName: "불콩불콩",
        blogId: 6425272,
        blogTitle: "콩's 다이어리",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/6425272/attach/43f95c1f85f6446ab7f49c9ebf08dc0c",
        blogUrl: "https://altlana1030.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/O85ar/btsCsp9naE2/k2wAOK4sLIfranNJYGAUF1/img.jpg",
        entryId: 66,
        entryTitle: "경기 곤지암맛집\n곤지곤지. 대구탕맛집",
        entryUrl:
          "https://altlana1030.tistory.com/entry/%EA%B2%BD%EA%B8%B0-%EA%B3%A4%EC%A7%80%EC%95%94%EB%A7%9B%EC%A7%91-%EA%B3%A4%EC%A7%80%EA%B3%A4%EC%A7%80-%EB%8C%80%EA%B5%AC%ED%83%95%EB%A7%9B%EC%A7%91",
        entrySummary:
          "해장하고 싶을땐 곤지암 곤지곤지대구탕 고고 곧 꽉찬다. 회전률도 좋은데 메뉴는 이게다다.딱 네가지 포장도 되다 반찬도. 딱 네가지다 파하트. 또. 차자줬다 국물 한번 더 리필 친절하게 해주신다 1 위치 경기 광주시 곤지암읍 경충대로571 곤지암역 1번출구에서 400m 2 영업시간 시작 09:00 종료 21:00 정기휴무. 월요일 전화번호 031-769-4194 3 총평 맛\uD83D\uDCA5\uD83D\uDCA5\uD83D\uDCA5\uD83D\uDCA5\uD83D\uDCA5 국물이. 끝내준다 서비스❤️❤️❤️❤️❤️ 반찬도 빨리빨리 리필해주고 국물추가도 화끈하게해주신다 가격\uD83D\uDE2D\uD83D\uDE2D 비싸다. 또올랐다 대구탕 한그릇 16, 000원 대구튀김 45,000원 대구뽈때기찜45, 000원 곤지암 곤지곤지 대구탕 신발벗고. 들어간다 불편하지만 지금은 겨울이다. 그러나 전기장판이 바닥이라. 추운날씨에. 딱이다 메뉴..",
        serviceCategoryName: "맛집",
        reactionCount: 155,
        commentCount: 190,
        entryPublished: "2023-12-22T07:07:16+09:00",
        firstReactionCreated: "2024-06-11T15:27:37.001035+09:00",
        isSupportBlog: true,
        supportCount: 2,
        supporters: [
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://tistory1.daumcdn.net/tistory/6067065/attach/2bf366f669d04088a24ca44bfa15879d",
          },
        ],
      },
      {
        authorId: 6105614,
        authorName: "브리즈17",
        blogId: 6223982,
        blogTitle: "브리즈 해방일지",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/6223982/attach/c79265134f7e46ba91845656627873f5",
        blogUrl: "https://breeze117.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/czTpFl/btsHSpcpIFz/hk8yJXXrABXcKimFz6cUDK/img.jpg",
        entryId: 226,
        entryTitle:
          "[후쿠오카 맛집] 쇼쿠도미츠_가성비만점/웨이팅헬 타이센동 맛집",
        entryUrl: "https://breeze117.tistory.com/226",
        entrySummary:
          "[후쿠오카 맛집] 쇼쿠도미츠후쿠오카 인기 1위 이자카 ■ 기본정보위치야나기바시 시장https://maps.app.goo.gl/ehjEa5aJduciHKfS6 쇼쿠도 미츠 · 일본 〒810-0003 Fukuoka, Chuo Ward, Haruyoshi, 1 Chome−6−1 柳橋連合市場 内★★★★★ · 일본 음식점www.google.com 영업시간월-토 10:00 - 14:00 / 17:30 - 21:00* 휴무*카이센동은 점심에만 판매 예약예약 불가오픈 전 웨이팅리스트 작성 가능 평점★★★★☆가성비 갑신선도 갑서비스 굿현금만 받음웨이팅은 다소 버겁다.. 숙소가 가깝다면 추천■ 방문후기후리뷰에 맛집 간증글이 넘쳐나는 쇼쿠도 미츠에 방문했다.야나기바시 시장에 위치한 카이센동 맛집이다.지하철 와타나베도리역에서..",
        serviceCategoryName: "해외여행",
        reactionCount: 3,
        commentCount: 3,
        entryPublished: "2024-06-10T23:41:59+09:00",
        firstReactionCreated: "2024-06-11T15:27:37.01102+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 4594289,
        authorName: "쓰소미",
        blogId: 4263461,
        blogTitle: "내손에클릭",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/4263461/attach/5c50090c056c476eb3a0b08c5335027e",
        blogUrl: "https://handclick.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/b248tR/btsHTE8SF1i/RIVdeHMaHJ0Gz6Zl8TPnl1/img.jpg",
        entryId: 235,
        entryTitle: "[서울 / 신도림] 카페 라임라빋 후기",
        entryUrl: "https://handclick.tistory.com/235",
        entrySummary:
          "오늘은 서울 신도림에 위치한 라임라빋 카페 후기입니다\uD83D\uDE0A 가끔 멀리 사는 언니를 만날 때면 신도림에서 만나고는 하는데신도림역에서 최대한 가까운 위치에서 모든 것을 해결하려고 하는 편이에요ㅋㅋ신도림까지 가는 것도 일이기 때문에...\uD83D\uDE05 밥먹다가 찾은 카페 라임라빋은 발음부터 특이해요. 영어로 Lime Rabit 으로 표기하더라고요.  이 날은 하필 비까지 내렸어요. 그래도 예쁜 위치에서 사진 한 컷은 남기고 들어갑니다\uD83D\uDE04 카페는 1층~2층으로 사용되는데 1층에는 사람이 있어서 사진을 못 찍었어요..\uD83E\uDD23카운터랑 메뉴판 아무것도 못 찍었더라고요.... 힝 아쉬워요. 재방문하면 찍어서 추가로 사진 올릴게요ㅎㅎ  카페 라임라읻은 정원 카페답게 계단에서부터 곳곳에 이렇게 푸릇푸릇한 친구들이 많아요\uD83C\uDF31  2층에 올라..",
        serviceCategoryName: "카페·디저트",
        reactionCount: 48,
        commentCount: 41,
        entryPublished: "2024-06-11T11:22:30+09:00",
        firstReactionCreated: "2024-06-11T15:27:37.018693+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "travel",
    hasNext: false,
  },
};

export const dummyItemTravel = {
  error: false,
  data: {
    lastPublished: 1718077642000,
    list: [
      {
        uniqueId: "6947745_174",
        title: "김천 1박 2일 여행코스 추천.",
        summary:
          "최근 따뜻한 날씨가 이어지면서, 많은 분들이 바쁜 일상에서 벗어나 여행을 계획하고 계실 텐데요. 오늘은 대구 근교에 위치한 김천의 멋진 여행지를 소개해드리겠습니다. 김천은 다양한 매력을 가진 장소들이 많아, 낮과 밤 모두 특별한 경험을 선사합니다. 그 중에서도 사명대사공원, 한복체험관, 카페 솔향을 중심으로 한 코스를 추천드립니다.  힐링뷰 맛집 사..",
        userId: 6596830,
        userName: "└ⓒ②ⓖⓘⓓ」",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6947745/attach/efc17ecedb174e86b38103d68c741dac",
        categoryName: "국내여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/y0IO0/btsHVUbrS8N/EtMNUfkmGd2TDQlrL3KWMK/img.png",
        link: "https://wangteun.tistory.com/174",
        blogId: 6947745,
        blogTitle: "쪼꼬쪼꼬",
        likeCount: 6,
        commentCount: 1,
        firstReactionCreated: 1718086059000,
        published: "2024.06.11 15:07",
        publishedAgo: "20분 전",
        supportCount: 0,
        encodedTitle:
          "%EA%B9%80%EC%B2%9C%201%EB%B0%95%202%EC%9D%BC%20%EC%97%AC%ED%96%89%EC%BD%94%EC%8A%A4%20%EC%B6%94%EC%B2%9C.",
        encodedUserName:
          "%E2%94%94%E2%93%92%E2%91%A1%E2%93%96%E2%93%98%E2%93%93%E3%80%8D",
      },
      {
        uniqueId: "5434334_284",
        title:
          "디지털 관광주민증 발급/사용방법 총정리(스타벅스 기프티콘 증정 이벤트 중)",
        summary:
          "혹시 여행을 계획 중이지만 경비가 부담이 되신다면 이 글을 끝까지 읽어보세요. 국내여행 시 여행에 필요한 경비들을 할인해 주는 디지털 관광주민증을 발급받아 사용하신다면 여행 비용을 확실하게 절감할 수 있습니다. 디지털 관광주민증의 발급 방법 및 사용 방법을 아래에서 확인하세요.  ≣ Contents 디지털 관광주민증 혜택 안내 디지털 관광주민증은 ..",
        userId: 5442142,
        userName: "흰돌",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5434334/attach/56d3c8961323450aa676224a3e53c1d1",
        categoryName: "해외여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/bUTo1u/btsHU6iHVMC/dKHvtsisQwPJ5R3hBXwD7k/img.png",
        link: "https://target1.bonusjackpot.co.kr/284",
        blogId: 5434334,
        blogTitle: "Bonus Jackpot",
        likeCount: 7,
        commentCount: 0,
        firstReactionCreated: 1718083603000,
        published: "2024.06.11 14:20",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%94%94%EC%A7%80%ED%84%B8%20%EA%B4%80%EA%B4%91%EC%A3%BC%EB%AF%BC%EC%A6%9D%20%EB%B0%9C%EA%B8%89%2F%EC%82%AC%EC%9A%A9%EB%B0%A9%EB%B2%95%20%EC%B4%9D%EC%A0%95%EB%A6%AC%28%EC%8A%A4%ED%83%80%EB%B2%85%EC%8A%A4%20%EA%B8%B0%ED%94%84%ED%8B%B0%EC%BD%98%20%EC%A6%9D%EC%A0%95%20%EC%9D%B4%EB%B2%A4%ED%8A%B8%20%EC%A4%91%29",
        encodedUserName: "%ED%9D%B0%EB%8F%8C",
      },
      {
        uniqueId: "5455232_9605",
        title:
          "강원도 동해 6월 가볼만한곳 :: 2024 무릉별유천지 라벤더축제  (1부) 【24년6월9일】",
        summary:
          '2024 동해 무릉별유천지 라벤더축제  (1부)      "보랏빛 매력에 풍덩" 6월8일~23일까지 16일간 보라빛 향연          초여름 보랏빛 향기 가득 품은 라벤더축제가 오는 8일부터 23일까지 16일 동안 강원 동해 무릉별유천지에서 열린다.            무릉별유천지에는 약 7천 평 규모의 야외..',
        userId: 5458574,
        userName: "아젤리아",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5455232/attach/0e210832f8d94c7b85a9ba7e1f200991",
        categoryName: "국내여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/RQlLP/btsHTIKgHq3/5pMQNC9YVQsmySo3b71RNk/img.jpg",
        link: "https://skdywjd25.tistory.com/entry/강원도-동해-6월-가볼만한곳-2024-무릉별유천지-라벤더축제-1부-【24년6월9일】",
        blogId: 5455232,
        blogTitle: "산행과여행 사진으로 말한다",
        likeCount: 6,
        commentCount: 3,
        firstReactionCreated: 1718083575000,
        published: "2024.06.11 14:23",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EA%B0%95%EC%9B%90%EB%8F%84%20%EB%8F%99%ED%95%B4%206%EC%9B%94%20%EA%B0%80%EB%B3%BC%EB%A7%8C%ED%95%9C%EA%B3%B3%20%3A%3A%202024%20%EB%AC%B4%EB%A6%89%EB%B3%84%EC%9C%A0%EC%B2%9C%EC%A7%80%20%EB%9D%BC%EB%B2%A4%EB%8D%94%EC%B6%95%EC%A0%9C%20%20%281%EB%B6%80%29%20%E3%80%9024%EB%85%846%EC%9B%949%EC%9D%BC%E3%80%91",
        encodedUserName: "%EC%95%84%EC%A0%A4%EB%A6%AC%EC%95%84",
      },
      {
        uniqueId: "5468769_295",
        title:
          "유럽 스페인 마드리드 해산물 빠에야 이베리코 스테이크 맛집 D`stapa",
        summary:
          "유럽 스페인 마드리드 해산물 빠에야 이베리코 스테이크 맛집 D`stapaD`stapahttps://maps.app.goo.gl/yynoo3Evp9MSfWLe8 D'stapa · C. de Segovia, 8, Centro, 28005 Madrid, 스페인★★★★★ · 쌀 전문식당www.google.com스페인에 유명한 음식이 바로  이베리코와 빠에야다. 그 두가지를 동시에 맛볼 수 있는 식당이 숙소 근처에 있어서 방문..",
        userId: 5469032,
        userName: "4년차",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5468769/attach/0a3532e401de4ba689902df38c55b99a",
        categoryName: "해외여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/nBt8q/btsHBXunvlC/DNlL6X91R3G5MpkA1VuC6k/img.jpg",
        link: "https://semi0-0.tistory.com/295",
        blogId: 5468769,
        blogTitle: "술마시는 회사원 일기",
        likeCount: 5,
        commentCount: 7,
        firstReactionCreated: 1718080124000,
        published: "2024.06.11 13:00",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9C%A0%EB%9F%BD%20%EC%8A%A4%ED%8E%98%EC%9D%B8%20%EB%A7%88%EB%93%9C%EB%A6%AC%EB%93%9C%20%ED%95%B4%EC%82%B0%EB%AC%BC%20%EB%B9%A0%EC%97%90%EC%95%BC%20%EC%9D%B4%EB%B2%A0%EB%A6%AC%EC%BD%94%20%EC%8A%A4%ED%85%8C%EC%9D%B4%ED%81%AC%20%EB%A7%9B%EC%A7%91%20D%60stapa",
        encodedUserName: "4%EB%85%84%EC%B0%A8",
      },
      {
        uniqueId: "5455517_3725",
        title: "{스페인 바르셀로나} 바위산에 위치해 있는 몬세라트 수도원",
        summary:
          "바위산에 위치해 있는 몬세라트 수도원  스페인 포르투갈 여행 9일차 바르셀로나 BCN 이벤트 호텔에서이른 아침에 조식을 먹고 관광버스로 약 1시간을 달려서 신비로운 기암 절벽의 도시 '몬세라트'에 도착을 한다. 몬세라트는 스페인어로 ‘톱으로 썬’이라는 뜻을 가질 정도로 신기한 모양의 절벽 바위들로 이루어진 지역이며 이 몬세라트의 광경을 보..",
        userId: 5458805,
        userName: "꼬끼오2",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5455517/attach/04833e7bd987448aa8d0158b37559e8a",
        categoryName: "해외여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/bPGpys/btsHncZRzuL/pjcc7GDPoS8j4o80pswKA1/img.jpg",
        link: "https://sgh4609.tistory.com/entry/32-스페인-바르셀로나-바위산에-위치해-있는-몬세라트-수도원",
        blogId: 5455517,
        blogTitle: "▶꼬끼오 티스토리(tistory)  그리운  추억을 ~",
        likeCount: 15,
        commentCount: 11,
        firstReactionCreated: 1718079833000,
        published: "2024.06.11 13:23",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%7B%EC%8A%A4%ED%8E%98%EC%9D%B8%20%EB%B0%94%EB%A5%B4%EC%85%80%EB%A1%9C%EB%82%98%7D%20%EB%B0%94%EC%9C%84%EC%82%B0%EC%97%90%20%EC%9C%84%EC%B9%98%ED%95%B4%20%EC%9E%88%EB%8A%94%20%EB%AA%AC%EC%84%B8%EB%9D%BC%ED%8A%B8%20%EC%88%98%EB%8F%84%EC%9B%90",
        encodedUserName: "%EA%BC%AC%EB%81%BC%EC%98%A42",
      },
      {
        uniqueId: "4062308_806",
        title: "용인시 기흥구 중동 집밥 식당 점심 '한식뷔페'",
        summary:
          "용인시 기흥구 중동 집밥 식당 점심 '한식뷔페'오늘점심은 한식뷔페... 밖에 집밥뷔페라고 쓰여있기는 한데 네이버지도에는 한식뷔페라고 뜬다... 건물 4층에 위치한 매장은 쾌적한 편이다... 하지만 시설이 너무 노후됐다...밥은 두 종류...계란국...각종 반찬들...이날 메인은 닭도리탕이었는데 늦게 가서 거의 남아있지 않았다... \uD83D\uDE2D 울며 겨자 먹기로 다 먹어갈 즈..",
        userId: 4469597,
        userName: "퍼플디자인",
        userImage:
          "https://tistory1.daumcdn.net/tistory/4062308/attach/11d40e11dd724204abdde5b2b94c7925",
        categoryName: "맛집",
        thumbnail:
          "https://k.kakaocdn.net/dn/cDiOAu/btsHVayWetj/mkCwh2wxZCGJ8cCgw9NjTk/img.jpg",
        link: "https://purple-id.tistory.com/806",
        blogId: 4062308,
        blogTitle: "purpledesign",
        likeCount: 20,
        commentCount: 21,
        firstReactionCreated: 1718079637000,
        published: "2024.06.11 13:20",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9A%A9%EC%9D%B8%EC%8B%9C%20%EA%B8%B0%ED%9D%A5%EA%B5%AC%20%EC%A4%91%EB%8F%99%20%EC%A7%91%EB%B0%A5%20%EC%8B%9D%EB%8B%B9%20%EC%A0%90%EC%8B%AC%20%27%ED%95%9C%EC%8B%9D%EB%B7%94%ED%8E%98%27",
        encodedUserName: "%ED%8D%BC%ED%94%8C%EB%94%94%EC%9E%90%EC%9D%B8",
      },
      {
        uniqueId: "5603416_11341972",
        title:
          "강원 영월 구룡산(966m), 된불데기산(908m) 비에 흠뻑 젖은 奧地 산행(2024.6.8)",
        summary:
          "『 비내리는 영월 구룡산, 된불데기산의 위협적인 급경사 구간을 흠뻑 젖은 채 걸어가다. 』 ■ 산행기록 개요1. 산 이 름 : 구룡산, 된불데기산(九龍山, 전국 1,000대명산)2. 위 치 : 강원도 영월군3. 높 이 : 966미터, 908미터4. 산행일시 : 2024. 6. 8(토) 09:20-14:35 (5시간15분, 순수산행시간 4시간30분)5. 산행거리 : 10.8km6. 산행코스 : 운학교 → 구룡산 ..",
        userId: 1181305,
        userName: "日新우일신",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5603416/attach/1e439c2e5d8c48dfaa330733c59bd515",
        categoryName: "캠핑·등산",
        thumbnail:
          "https://k.kakaocdn.net/dn/cunxu8/btsHRnmxfqG/07OHqtYcmnsi7WBHrHBli0/img.jpg",
        link: "https://2hl2sej.tistory.com/entry/강원-영월-구룡산-된불데기산",
        blogId: 5603416,
        blogTitle: "100대명산과 함께 하는 새로운 하루",
        likeCount: 10,
        commentCount: 2,
        firstReactionCreated: 1718079115000,
        published: "2024.06.11 13:11",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EA%B0%95%EC%9B%90%20%EC%98%81%EC%9B%94%20%EA%B5%AC%EB%A3%A1%EC%82%B0%28966m%29%2C%20%EB%90%9C%EB%B6%88%EB%8D%B0%EA%B8%B0%EC%82%B0%28908m%29%20%EB%B9%84%EC%97%90%20%ED%9D%A0%EB%BB%91%20%EC%A0%96%EC%9D%80%20%E5%A5%A7%E5%9C%B0%20%EC%82%B0%ED%96%89%282024.6.8%29",
        encodedUserName: "%E6%97%A5%E6%96%B0%EC%9A%B0%EC%9D%BC%EC%8B%A0",
      },
      {
        uniqueId: "457261_3142",
        title: "양산 해양산국밥 북정동 우동국밥 맛집",
        summary:
          "여러분 안녕하세요, GeniusJW 입니다.오늘 소개해드릴 가게는 경남 양산에 위치한 우동국밥 맛집 입니다.해양산국밥은 독특하게 우동과 국밥을 합쳐놓은 하이브리드(?) 메뉴를 판매하고 있었습니다. 그럼 이제 우동국밥 맛집인 해양산국밥을 알아보러 함께 가실까요? ■ 가게위치 및 정보  해양산국밥은 경남 양산시 북정동 907-1 에 위치한 가게였는데, 해양..",
        userId: 414600,
        userName: "GeniusJW",
        userImage:
          "https://tistory1.daumcdn.net/tistory/457261/attach/35114178d7584e6ba33a425b3b92e4d9",
        categoryName: "맛집",
        thumbnail:
          "https://k.kakaocdn.net/dn/c6tsgR/btsHTTrtVcH/vXYJ5ZfH3QCUI6FV34u3c1/img.jpg",
        link: "https://geniusjw.com/3142",
        blogId: 457261,
        blogTitle: "GeniusJW",
        likeCount: 10,
        commentCount: 2,
        firstReactionCreated: 1718078815000,
        published: "2024.06.11 13:04",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%96%91%EC%82%B0%20%ED%95%B4%EC%96%91%EC%82%B0%EA%B5%AD%EB%B0%A5%20%EB%B6%81%EC%A0%95%EB%8F%99%20%EC%9A%B0%EB%8F%99%EA%B5%AD%EB%B0%A5%20%EB%A7%9B%EC%A7%91",
        encodedUserName: "GeniusJW",
      },
      {
        uniqueId: "6487834_2613",
        title: "프랑스 파리 핵심 하루투어 (예술&미식&역사&로컬)",
        summary:
          "프랑스 파리 핵심 하루투어 (예술&미식&역사&로컬) \uD83D\uDCAB파리 여행의 첫 걸음은 '여행의신'에서! 파리를 탐험하는데 어려움을 겪는다면, 여행의신이 와줍니다. 온라인으로 예약할 수 있는 파리시내 하루투어로 여행의 시작을 즐겁게 만들어보세요. \uD83D\uDCAB효율적인 일정으로 파리를 만나다 파리의 아름다움과 매력을 하루 안에 담아..",
        userId: 6294414,
        userName: "랜선_세계여행",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6487834/attach/ff3b06f3ffe44f05823418905fbb9f33",
        categoryName: "해외여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/cvrKSV/btsHSaGNeb7/6kV2lkrKu5ZAJKXg4KMAKk/img.jpg",
        link: "https://travel-hotel-culinary.tistory.com/2613",
        blogId: 6487834,
        blogTitle: "집에서 떠나는 _랜선 세계여행✈",
        likeCount: 5,
        commentCount: 6,
        firstReactionCreated: 1718078656000,
        published: "2024.06.11 13:00",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%94%84%EB%9E%91%EC%8A%A4%20%ED%8C%8C%EB%A6%AC%20%ED%95%B5%EC%8B%AC%20%ED%95%98%EB%A3%A8%ED%88%AC%EC%96%B4%20%28%EC%98%88%EC%88%A0%26%EB%AF%B8%EC%8B%9D%26%EC%97%AD%EC%82%AC%26%EB%A1%9C%EC%BB%AC%29",
        encodedUserName:
          "%EB%9E%9C%EC%84%A0_%EC%84%B8%EA%B3%84%EC%97%AC%ED%96%89",
      },
      {
        uniqueId: "5366780_18",
        title: "디지털 관광주민증으로 스타벅스 1만원권 받는 방법(feat. 이벤트)",
        summary:
          "이번달부터 디지털 관광주민증으로 할인받으면서 관광할 수 있게 되었습니다. 자세한 사항은 아래 디지털 관광주민증을 클릭하시면 해당페이지로 이동합니다.   대표적 할인경기 가평군 가평브릿지짚라인 체험 20% 할인전북 임실군 치즈테마파크 체험 10% 할인충북 영동군 일라이트호텔 30% 할인경북 영덕 고래불국민야영장 20% 할인 등 관광주민증을 ..",
        userId: 5375633,
        userName: "지구여행97",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5366780/attach/a48f9156304e479499c31ed76330586a",
        categoryName: "국내여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/bfsCy8/btsHR7pB49M/wk7LkVIsIwSdelMO1bW1lk/img.jpg",
        link: "https://sook.sook1216.com/18",
        blogId: 5366780,
        blogTitle: "여기저기 여행이야기",
        likeCount: 14,
        commentCount: 2,
        firstReactionCreated: 1718078476000,
        published: "2024.06.10 09:07",
        publishedAgo: "어제",
        supportCount: 0,
        encodedTitle:
          "%EB%94%94%EC%A7%80%ED%84%B8%20%EA%B4%80%EA%B4%91%EC%A3%BC%EB%AF%BC%EC%A6%9D%EC%9C%BC%EB%A1%9C%20%EC%8A%A4%ED%83%80%EB%B2%85%EC%8A%A4%201%EB%A7%8C%EC%9B%90%EA%B6%8C%20%EB%B0%9B%EB%8A%94%20%EB%B0%A9%EB%B2%95%28feat.%20%EC%9D%B4%EB%B2%A4%ED%8A%B8%29",
        encodedUserName: "%EC%A7%80%EA%B5%AC%EC%97%AC%ED%96%8997",
      },
      {
        uniqueId: "5338467_93",
        title: "여행가는 달 '만만한 캠핑' 캠핑장 할인 받는 방법 3가지",
        summary:
          "여행가기 좋은 날이 이어지고 있습니다. 여행가는 달을 맞이하여 등록된 캠핑장을 예약하고 이용하였을때 1만원 할인 받는 방법이 있는데요.캠핑장 1만원 할인 받는 3가지 방법을 알려드릴게요.  예약플랫폼은 네이버, 캠핏, 땡큐캠핑입니다.이용대상은 오토캠핑, 카라반, 글램핑이고 예약기간은 6월 27일까지입니다.캠핑장 이용기간은 6월 30일까지이고 발..",
        userId: 5371501,
        userName: "찐쓰",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5338467/attach/b3069f6340994177bb6a6c5b4a4b707b",
        categoryName: "국내여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/lmJKK/btsHUpiAHQO/CLoE2RZsIfqzbKdLuNQsNK/img.png",
        link: "https://jjins0113.com/93",
        blogId: 5338467,
        blogTitle: "찐쓰",
        likeCount: 14,
        commentCount: 2,
        firstReactionCreated: 1718078472000,
        published: "2024.06.11 09:37",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%97%AC%ED%96%89%EA%B0%80%EB%8A%94%20%EB%8B%AC%20%27%EB%A7%8C%EB%A7%8C%ED%95%9C%20%EC%BA%A0%ED%95%91%27%20%EC%BA%A0%ED%95%91%EC%9E%A5%20%ED%95%A0%EC%9D%B8%20%EB%B0%9B%EB%8A%94%20%EB%B0%A9%EB%B2%95%203%EA%B0%80%EC%A7%80",
        encodedUserName: "%EC%B0%90%EC%93%B0",
      },
      {
        uniqueId: "5599069_7985",
        title: "해드린청허하우스 양파 첫 수확",
        summary:
          "해드린청허하우스 양파 첫 수확 귀촌한 후 양파는 첫 수확입니다.2023.10.25일 양파 모종을 심은 후 209일이 지난 2024.06.04일 양파를 첫 수확을 했습니다.양파 첫 수확하고 있습니다. 양파 첫 수확             수확한 양파 수확한 양파   수확한 양파  해드린청허하우스 텃밭에서 양파를 첫 수확하여 우리의 양식을 주셔서 감사합니다...",
        userId: 5579890,
        userName: "기리여원",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5599069/attach/19870c905acf40a7b6e1fae7e4f96ae6",
        categoryName: "국내여행",
        thumbnail:
          "https://k.kakaocdn.net/dn/kUAHY/btsHTgtSxJJ/xy1S00ocU54EYQQp1WmBS0/img.jpg",
        link: "https://99sangk.tistory.com/entry/해드린청허하우스-양파-첫-수확",
        blogId: 5599069,
        blogTitle: "기리여원",
        likeCount: 21,
        commentCount: 7,
        firstReactionCreated: 1718077642000,
        published: "2024.06.11 12:46",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%ED%95%B4%EB%93%9C%EB%A6%B0%EC%B2%AD%ED%97%88%ED%95%98%EC%9A%B0%EC%8A%A4%20%EC%96%91%ED%8C%8C%20%EC%B2%AB%20%EC%88%98%ED%99%95",
        encodedUserName: "%EA%B8%B0%EB%A6%AC%EC%97%AC%EC%9B%90",
      },
    ],
    category: "travel",
    hasNext: true,
  },
};

export const dummyItemTravel2 ={
  "error": false,
  "data": {
    "lastPublished": 1718883484000,
    "list": [
      {
        "uniqueId": "5320127_10",
        "title": "맥도날드 감자튀김 판매중단, 공급망 문제로..",
        "summary": "https://www.yna.co.kr/view/AKR20240620092051030?input=1195m 한국맥도날드, 또 감자튀김 판매 중단…\"냉동감자 기준 미달\"(종합) | 연합뉴스(서울=연합뉴스) 김윤구 기자 = 한국맥도날드가 또다시 감자튀김(후렌치 후라이) 판매를 일시 중단했다.www.yna.co.kr 코로나 이후 다시 발생한 감자튀김 이슈코로나때 롯데리아를 포함해서 여러 패스트 푸드점..",
        "userId": 4683313,
        "userName": "개드립퍼",
        "userImage": "https://tistory1.daumcdn.net/tistory/5320127/attach/8b7e82d6ee5c41e1be60100c898996fa",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/uaiEz/btsH50qCGIF/SmglGxuHrG7ytnRnkbvmak/img.png",
        "link": "https://dogdripp.tistory.com/10",
        "blogId": 5320127,
        "blogTitle": "실시간 이슈를 찾아서",
        "likeCount": 5,
        "commentCount": 0,
        "firstReactionCreated": 1718890733000,
        "published": "2024.06.20 22:38",
        "publishedAgo": "8분 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A7%A5%EB%8F%84%EB%82%A0%EB%93%9C%20%EA%B0%90%EC%9E%90%ED%8A%80%EA%B9%80%20%ED%8C%90%EB%A7%A4%EC%A4%91%EB%8B%A8%2C%20%EA%B3%B5%EA%B8%89%EB%A7%9D%20%EB%AC%B8%EC%A0%9C%EB%A1%9C..",
        "encodedUserName": "%EA%B0%9C%EB%93%9C%EB%A6%BD%ED%8D%BC"
      },
      {
        "uniqueId": "757227_6350",
        "title": "커피빈 스파클링 매화 자스민 자몽",
        "summary": "이번에 마셔본 프랜차이즈 카페 음료는 커피빈 스파클링 매화 자스민 자몽이에요. 모처럼 친구를 만났어요. 제주도 여행 갔을 때 친구가 먼저 제주도 내려가 있었어요. 그래서 제주도 내려갔을 때 만난 후 여행 마치고 돌아와서 서울에서 처음 만났어요. 친구와는 저녁식사를 같이 먹었어요. 저녁 식사를 다 먹은 후 느긋하게 같이 밤 거리를 산책했어요. \"밤 되니..",
        "userId": 578506,
        "userName": "좀좀이",
        "userImage": "https://t1.daumcdn.net/cfile/tistory/166A39474FD3A57F2C",
        "categoryName": "카페·디저트",
        "thumbnail": "https://k.kakaocdn.net/dn/cbVkn9/btsH7UWyzYF/kaiw93TsPA4lPknrRjfvh0/img.jpg",
        "link": "https://zomzom.tistory.com/6350",
        "blogId": 757227,
        "blogTitle": "좀좀이의 여행",
        "likeCount": 6,
        "commentCount": 0,
        "firstReactionCreated": 1718889704000,
        "published": "2024.06.20 22:21",
        "publishedAgo": "25분 전",
        "supportCount": 0,
        "encodedTitle": "%EC%BB%A4%ED%94%BC%EB%B9%88%20%EC%8A%A4%ED%8C%8C%ED%81%B4%EB%A7%81%20%EB%A7%A4%ED%99%94%20%EC%9E%90%EC%8A%A4%EB%AF%BC%20%EC%9E%90%EB%AA%BD",
        "encodedUserName": "%EC%A2%80%EC%A2%80%EC%9D%B4"
      },
      {
        "uniqueId": "6602815_239",
        "title": "술과 곁들이는 아이스크림바. 왠지 멋진 어른이 된 기분을 즐겨보자.",
        "summary": "즐거운 술자리 1차를 하고~^^ 배부를 때 2차로 가기 딱 좋은 아이스크림 바 3곳을 소개합니다. 술과 페어링 해서 왠지 멋진 어른이 된 기분을 즐겨보자.살리르살리르 Pretzel, Bacon chip 아이스크림 [출처] 살리르 이곳에서 마음에 드는 아이스크림을 선택하면, 사장님께서 그에 어울리는 술을 추천해 주십니다. 아이스크림 메뉴는 매우 실험적입니다. 예를 들어 '..",
        "userId": 6380366,
        "userName": "【 hoya 】",
        "userImage": "https://tistory1.daumcdn.net/tistory/6602815/attach/8a87df052d4b4ad1bdabed26a12da084",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/b6ZonF/btsH5NyeYtF/lqyRMTKAn5YFRyVjmgUMnk/img.jpg",
        "link": "https://jinsostory.tistory.com/239",
        "blogId": 6602815,
        "blogTitle": "hoya 세상 톡톡",
        "likeCount": 5,
        "commentCount": 3,
        "firstReactionCreated": 1718888455000,
        "published": "2024.06.20 21:58",
        "publishedAgo": "48분 전",
        "supportCount": 0,
        "encodedTitle": "%EC%88%A0%EA%B3%BC%20%EA%B3%81%EB%93%A4%EC%9D%B4%EB%8A%94%20%EC%95%84%EC%9D%B4%EC%8A%A4%ED%81%AC%EB%A6%BC%EB%B0%94.%20%EC%99%A0%EC%A7%80%20%EB%A9%8B%EC%A7%84%20%EC%96%B4%EB%A5%B8%EC%9D%B4%20%EB%90%9C%20%EA%B8%B0%EB%B6%84%EC%9D%84%20%EC%A6%90%EA%B2%A8%EB%B3%B4%EC%9E%90.",
        "encodedUserName": "%E3%80%90%20hoya%20%E3%80%91"
      },
      {
        "uniqueId": "6365276_602",
        "title": "알프스의 상징, 스위스 \u003C  마테호른  \u003E  정상을 향한 여행! 222",
        "summary": "알프스의 상징, 스위스 마테호른 정상을 향한 여행! 222 4. 마테호른 등반: 신중한 준비와 도전 마테호른 등반은 숙련된 등산가들에게만 추천하는 험난한 코스입니다. 충분한 체력과 경험을 갖춘 등산객만이 안전하게 정상을 오를 수 있습니다.등반 준비: 체력 단련: 마테호른 등반은 상당한 체력을 요구합니다. 등반 전에 충분한 트레이닝을 통해 체력을 단련해..",
        "userId": 5403671,
        "userName": "티스토리짱짱",
        "userImage": "https://tistory1.daumcdn.net/tistory/6365276/attach/791b5b835f1644469f35bf768f15f9f5",
        "categoryName": "해외여행",
        "thumbnail": "https://k.kakaocdn.net/dn/ZM7bJ/btsHYnMNihT/K65HZMRQ1zibCkkh0lYMqK/img.png",
        "link": "https://jams37289418.tistory.com/602",
        "blogId": 6365276,
        "blogTitle": "티스토리짱",
        "likeCount": 13,
        "commentCount": 0,
        "firstReactionCreated": 1718888105000,
        "published": "2024.06.14 17:22",
        "publishedAgo": "6일 전",
        "supportCount": 0,
        "encodedTitle": "%EC%95%8C%ED%94%84%EC%8A%A4%EC%9D%98%20%EC%83%81%EC%A7%95%2C%20%EC%8A%A4%EC%9C%84%EC%8A%A4%20%3C%20%20%EB%A7%88%ED%85%8C%ED%98%B8%EB%A5%B8%20%20%3E%20%20%EC%A0%95%EC%83%81%EC%9D%84%20%ED%96%A5%ED%95%9C%20%EC%97%AC%ED%96%89%21%20222",
        "encodedUserName": "%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC%EC%A7%B1%EC%A7%B1"
      },
      {
        "uniqueId": "6922585_41",
        "title": "제주도 닭발 맛집 - 신봉닭발   *튤립닭발, 매운날개구이",
        "summary": "안녕하세요 제주도 닭발 맛집 신봉닭발집 소개해드리려 합니다 이곳은 원래 서울 군자에 위치해 있었는데 그때부터 즐겨 먹곤 했었거든요 제주도로 이전한다는 소식 듣고 반가웠습니다 ㅎㅎ        - 신봉닭발가게 간판에서부터 설레네요 오랜만에 먹는 신봉닭발,, 최애 중 하나였거든요    계단 따라 올라가..",
        "userId": 6581833,
        "userName": "헤드최",
        "userImage": "https://tistory1.daumcdn.net/tistory/6922585/attach/3c1fdf269a7b42458d3a8d96186efd0e",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/ca7CRV/btsH5BZaKmZ/bQ4PhK9JnxpSgKEoA5tlIK/img.png",
        "link": "https://haedchoi.tistory.com/41",
        "blogId": 6922585,
        "blogTitle": "20대 남자 블로거",
        "likeCount": 9,
        "commentCount": 2,
        "firstReactionCreated": 1718887723000,
        "published": "2024.06.20 21:48",
        "publishedAgo": "58분 전",
        "supportCount": 0,
        "encodedTitle": "%EC%A0%9C%EC%A3%BC%EB%8F%84%20%EB%8B%AD%EB%B0%9C%20%EB%A7%9B%EC%A7%91%20-%20%EC%8B%A0%EB%B4%89%EB%8B%AD%EB%B0%9C%20%20%20*%ED%8A%A4%EB%A6%BD%EB%8B%AD%EB%B0%9C%2C%20%EB%A7%A4%EC%9A%B4%EB%82%A0%EA%B0%9C%EA%B5%AC%EC%9D%B4",
        "encodedUserName": "%ED%97%A4%EB%93%9C%EC%B5%9C"
      },
      {
        "uniqueId": "7007660_38",
        "title": "금산 현지인의 로컬 맛집 홍송숯불구이 저와 부모님과의 찐 단골집입니다.",
        "summary": "안녕하세요. 도시농부입니다. 며칠 정말 뜨겁더니 오늘은 흐려서 그나마 뜨끈뜨끈하지는 않아서 조금 괜찮습니다. 아침부터 부모님께서 마늘을 정말 많이 수확해 놓으셨습니다. 연로하신 분들이 정말 쉬지 않으시고 농삿일을 하십니다.  어머님께서 점심은 밖에서 사먹자 하여~ 우리 셋의 최애 단골집에 가기로 했습니다. 제가 부모님 일을 돕기 시작하면서 다..",
        "userId": 4142497,
        "userName": "도시농부81",
        "userImage": "https://tistory1.daumcdn.net/tistory/7007660/attach/893de1064a7840c7b71df6355465e183",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/kEx50/btsH5PJybyo/6Jeqae0N0oWy6MEg0hRUkK/img.jpg",
        "link": "https://onnurihongsam.tistory.com/38",
        "blogId": 7007660,
        "blogTitle": "도시농부의 일상이야기",
        "likeCount": 7,
        "commentCount": 14,
        "firstReactionCreated": 1718887701000,
        "published": "2024.06.20 21:39",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EA%B8%88%EC%82%B0%20%ED%98%84%EC%A7%80%EC%9D%B8%EC%9D%98%20%EB%A1%9C%EC%BB%AC%20%EB%A7%9B%EC%A7%91%20%ED%99%8D%EC%86%A1%EC%88%AF%EB%B6%88%EA%B5%AC%EC%9D%B4%20%EC%A0%80%EC%99%80%20%EB%B6%80%EB%AA%A8%EB%8B%98%EA%B3%BC%EC%9D%98%20%EC%B0%90%20%EB%8B%A8%EA%B3%A8%EC%A7%91%EC%9E%85%EB%8B%88%EB%8B%A4.",
        "encodedUserName": "%EB%8F%84%EC%8B%9C%EB%86%8D%EB%B6%8081"
      },
      {
        "uniqueId": "1837878_3817",
        "title": "베트남 호치민 랜드마크에서 배달시켜 먹은 한식당 짜장면 배달 - Tiệm Mì Tương Đen Chaewon -",
        "summary": "베트남 호치민 랜드마크에서 베트남 호치민 에어비앤비 아파트 빈홈 센트럴파크 랜드마크 5 추천 - Vinhomes Central Park LANDMARK 5 -베트남 호치민빈홈랜드마크 5에어비앤비 리뷰입니다 가격은 평균적으로2024년5~6월 현재 기준 구조는우리나라에서1.5룸이라고 하나요방 하나거실 하나그리고거실에 딸린 주방화장실과 샤워실jongha1004.tistory.com..",
        "userId": 1379160,
        "userName": "천사종하",
        "userImage": "https://tistory1.daumcdn.net/tistory/1837878/attach/6e5993f5ad164cb5843649d02ad6ddac",
        "categoryName": "해외여행",
        "thumbnail": "https://k.kakaocdn.net/dn/sDjYI/btsH6LGekXh/679kb6q4nwuJdW8stuIFT1/img.png",
        "link": "https://jongha1004.tistory.com/3817",
        "blogId": 1837878,
        "blogTitle": "소소한 추억거리들...",
        "likeCount": 5,
        "commentCount": 2,
        "firstReactionCreated": 1718887188000,
        "published": "2024.06.20 21:15",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%B2%A0%ED%8A%B8%EB%82%A8%20%ED%98%B8%EC%B9%98%EB%AF%BC%20%EB%9E%9C%EB%93%9C%EB%A7%88%ED%81%AC%EC%97%90%EC%84%9C%20%EB%B0%B0%EB%8B%AC%EC%8B%9C%EC%BC%9C%20%EB%A8%B9%EC%9D%80%20%ED%95%9C%EC%8B%9D%EB%8B%B9%20%EC%A7%9C%EC%9E%A5%EB%A9%B4%20%EB%B0%B0%EB%8B%AC%20-%20Ti%E1%BB%87m%20M%C3%AC%20T%C6%B0%C6%A1ng%20%C4%90en%20Chaewon%20-",
        "encodedUserName": "%EC%B2%9C%EC%82%AC%EC%A2%85%ED%95%98"
      },
      {
        "uniqueId": "6487834_2651",
        "title": "[한국인전용] 나트랑 크레이지파티 요트 호핑투어 & 프라이빗 섬에서 즐기는 선상파티!",
        "summary": "[한국인전용] 나트랑 크레이지파티 요트 호핑투어 & 프라이빗 섬에서 즐기는 선상파티!  ⭐️ 한국인 전용 조인투어 나트랑에서 가장 신나는 경험을 원하시나요? 한국인끼리만 진행되는 이 특별한 투어에서, 언어 걱정 없이 편안하고 즐겁게 참여할 수 있습니다. 새로운 친구들과 함께하는 이 투어는 나트랑 여행의 하이..",
        "userId": 6294414,
        "userName": "랜선_세계여행",
        "userImage": "https://tistory1.daumcdn.net/tistory/6487834/attach/ff3b06f3ffe44f05823418905fbb9f33",
        "categoryName": "해외여행",
        "thumbnail": "https://k.kakaocdn.net/dn/k18Gg/btsH52OhwFs/kFBKOHorLjXI5PSQ1IYAP1/img.png",
        "link": "https://travel-hotel-culinary.tistory.com/2651",
        "blogId": 6487834,
        "blogTitle": "집에서 떠나는 _랜선 세계여행✈",
        "likeCount": 5,
        "commentCount": 5,
        "firstReactionCreated": 1718885368000,
        "published": "2024.06.20 21:00",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%5B%ED%95%9C%EA%B5%AD%EC%9D%B8%EC%A0%84%EC%9A%A9%5D%20%EB%82%98%ED%8A%B8%EB%9E%91%20%ED%81%AC%EB%A0%88%EC%9D%B4%EC%A7%80%ED%8C%8C%ED%8B%B0%20%EC%9A%94%ED%8A%B8%20%ED%98%B8%ED%95%91%ED%88%AC%EC%96%B4%20%26%20%ED%94%84%EB%9D%BC%EC%9D%B4%EB%B9%97%20%EC%84%AC%EC%97%90%EC%84%9C%20%EC%A6%90%EA%B8%B0%EB%8A%94%20%EC%84%A0%EC%83%81%ED%8C%8C%ED%8B%B0%21",
        "encodedUserName": "%EB%9E%9C%EC%84%A0_%EC%84%B8%EA%B3%84%EC%97%AC%ED%96%89"
      },
      {
        "uniqueId": "5452312_12885543",
        "title": "서울둘레길 3~4코스(24. 6. 8) 불암산 & 망우,용마산",
        "summary": "오늘은 서울 둘레길 3~ 4코스 총 14.6km를 걸었습니다.. - 3코스 : 당고개역 1번 출구~ 상계동나들이철쭉동산 ~ 넓은마당 ~ 불암산힐링타운 ~ 화랑대역(6.9km, 2시간 30분)  - 4코스 : 화랑대역 6호선 ~ 공릉동근린공원입구 ~신내어울공원입구 ~ 중량갬핑숲 ~ 망우역사문화공원 ~ 깔닥고개쉼터(7.7km, 3시간) 4코스의 망우리공원 인문학길 '사잇길'에는 ..",
        "userId": 5456225,
        "userName": "산사랑 1",
        "userImage": "https://tistory1.daumcdn.net/tistory/5452312/attach/1373122fff084a5da04e99dc0bd3ce9b",
        "categoryName": "캠핑·등산",
        "thumbnail": "https://k.kakaocdn.net/dn/snWEv/btsH1366Pcr/nFJAoXbiojuKqHo72HovBK/img.jpg",
        "link": "https://khk9228.tistory.com/entry/서울둘레길-34코스24-6-8-불암산-망우용마산",
        "blogId": 5452312,
        "blogTitle": "건  셀",
        "likeCount": 6,
        "commentCount": 6,
        "firstReactionCreated": 1718885335000,
        "published": "2024.06.20 21:00",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%84%9C%EC%9A%B8%EB%91%98%EB%A0%88%EA%B8%B8%203%7E4%EC%BD%94%EC%8A%A4%2824.%206.%208%29%20%EB%B6%88%EC%95%94%EC%82%B0%20%26%20%EB%A7%9D%EC%9A%B0%2C%EC%9A%A9%EB%A7%88%EC%82%B0",
        "encodedUserName": "%EC%82%B0%EC%82%AC%EB%9E%91%201"
      },
      {
        "uniqueId": "4351705_788",
        "title": "신선한 육회와 연어의 맛있는 조화, 가성비 좋은 육회바른연어 과천중앙점",
        "summary": "오늘 점심은 육회바른연어 과천중앙점에서 먹었습니다. 정부과천청사역 11번 출구에서 약 237m 거리에 위치해 있는데요. 오픈한 지 얼마 되지 않은 것 같더라고요.  육회바른연어 과천중앙점메뉴: 육회바른연어, 3단변신초밥, 연어혼밥세트, 타코와사비육회 등주소: 경기 과천시 관문로 92 B동 제지 1층 B101, 102호영업시간: 매일 11:00~ 22:00문의: 02. 6949. 4..",
        "userId": 4663344,
        "userName": "난짬뽕",
        "userImage": "https://tistory1.daumcdn.net/tistory/4351705/attach/bf0dd5daabda4cbfa643fd380962f715",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/4Ym9R/btsH5K77ZIB/yv3tTOmTsNyNBPBslmWO20/img.png",
        "link": "https://breezehu.tistory.com/788",
        "blogId": 4351705,
        "blogTitle": "짜장 먹고 싶다",
        "likeCount": 26,
        "commentCount": 29,
        "firstReactionCreated": 1718885242000,
        "published": "2024.06.20 21:00",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%8B%A0%EC%84%A0%ED%95%9C%20%EC%9C%A1%ED%9A%8C%EC%99%80%20%EC%97%B0%EC%96%B4%EC%9D%98%20%EB%A7%9B%EC%9E%88%EB%8A%94%20%EC%A1%B0%ED%99%94%2C%20%EA%B0%80%EC%84%B1%EB%B9%84%20%EC%A2%8B%EC%9D%80%20%EC%9C%A1%ED%9A%8C%EB%B0%94%EB%A5%B8%EC%97%B0%EC%96%B4%20%EA%B3%BC%EC%B2%9C%EC%A4%91%EC%95%99%EC%A0%90",
        "encodedUserName": "%EB%82%9C%EC%A7%AC%EB%BD%95"
      },
      {
        "uniqueId": "3922171_302",
        "title": "여수 초코파이, 쑥아이스크림 여수당",
        "summary": "목차1. 주소2. 연락처3. 영업시간4. 위치5. 주차장6. 홈페이지7. 여수당 🏡 주소전남 여수시 중앙로 72 📞 연락처0507-1356-0222 🕖 영업시간매일 07:30 - 22:00   🌏 위치      🚗 주차장없음 🗺️ 홈페이지https://smartstore.naver.com/yeosudang    수제바게트버거 여수당  수제 바게트 버거 여수당이라고 쓰..",
        "userId": 4389870,
        "userName": "상위 일프로",
        "userImage": "https://tistory1.daumcdn.net/tistory/3922171/attach/1c7200221e4a47cb90ef02dcb9641724",
        "categoryName": "맛집",
        "thumbnail": "https://k.kakaocdn.net/dn/cwtijX/btsH6TddV5r/QuPTJ4t5R0w7Zd96hKF2cK/img.png",
        "link": "https://1percenthome.tistory.com/302",
        "blogId": 3922171,
        "blogTitle": "상위일프로의 공간",
        "likeCount": 24,
        "commentCount": 24,
        "firstReactionCreated": 1718885036000,
        "published": "2024.06.20 21:03",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%97%AC%EC%88%98%20%EC%B4%88%EC%BD%94%ED%8C%8C%EC%9D%B4%2C%20%EC%91%A5%EC%95%84%EC%9D%B4%EC%8A%A4%ED%81%AC%EB%A6%BC%20%EC%97%AC%EC%88%98%EB%8B%B9",
        "encodedUserName": "%EC%83%81%EC%9C%84%20%EC%9D%BC%ED%94%84%EB%A1%9C"
      },
      {
        "uniqueId": "5692194_7733721",
        "title": "경기도 무료 계곡 베스트 12",
        "summary": "https://youtu.be/rmPfVEGpmBA?si=Pn8K1FLn01Zi_dq4",
        "userId": 5654126,
        "userName": "또바기1957",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "국내여행",
        "thumbnail": null,
        "link": "https://mihwang.tistory.com/entry/경기도-무료-계곡-베스트-12",
        "blogId": 5692194,
        "blogTitle": "참",
        "likeCount": 8,
        "commentCount": 5,
        "firstReactionCreated": 1718883484000,
        "published": "2024.06.20 19:50",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EA%B2%BD%EA%B8%B0%EB%8F%84%20%EB%AC%B4%EB%A3%8C%20%EA%B3%84%EA%B3%A1%20%EB%B2%A0%EC%8A%A4%ED%8A%B8%2012",
        "encodedUserName": "%EB%98%90%EB%B0%94%EA%B8%B01957"
      }
    ],
    "category": "travel",
    "hasNext": true
  }
}